/* Interactions copied in behaviour from the reference page (their sticky-cta, embla-carousel, accordion and buybox-gallery elements),
   written from scratch. Each part is wrapped so one failure cannot stop the others. */
(function () {
  var root = document.querySelector('.gx');
  if (!root) return;
  root.classList.add('gx-js');
  /* the store layout titles the tab with the page record's title; this page carries its own, like the reference */
  document.title = 'FisioRest | For Shoulder Blade Knots';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky bar: shows while neither the hero, the buy box nor the store's footer is on screen (their rule: no .hide-cta element visible).
     Set up once the document is parsed, because the store's footer comes after this script. */
  function sticky() {
    try {
      var bar = root.querySelector('.gx-top-3');
      var hide = [root.querySelector('.gx-top-2'), root.querySelector('#offers')]
        .concat([].slice.call(document.querySelectorAll('.shopify-section-group-footer-group'))).filter(Boolean);
      if (bar && hide.length && 'IntersectionObserver' in window) {
        var seen = new Map();
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
          var any = false; seen.forEach(function (v) { if (v) any = true; });
          bar.classList.toggle('is-on', !any);
        }, { threshold: 0 });
        hide.forEach(function (el) { seen.set(el, true); io.observe(el); });
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky); else sticky();

  /* Sale name: the store's countdown timer (Essential Countdown Timer, block cmuxqvxps002q117a1hiz4eo2, the bar at the top) holds the
     sale's title, e.g. "HALLOWEEN SALE". Every [data-sale] spot shows that name, so the page follows when the store renames the sale
     (7 Oct, Manuel's Loom 09:31). Any title is used, sale or not ("BLACK FRIDAY DEALS" too, 15 Oct, Miljan); only an empty title keeps the name written in the page. */
  function saleName() {
    try {
      var t = (window.essentialCountdownTimerConfigs || []).filter(function (x) { return x && x.id === 'cmuxqvxps002q117a1hiz4eo2'; })[0];
      var n = t && typeof t.title === 'string' ? t.title.replace(/\s+/g, ' ').replace(/[\s:]+$/, '').trim() : '';
      if (!n || /[a-z]/.test(n)) return n;   /* typed in mixed case: shown as typed */
      return n.toLowerCase().split(' ').map(function (w, i) {   /* typed in capitals: Title Case, small words lower */
        return i && /^(a|an|and|at|by|for|in|of|on|or|the|to|with)$/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
    } catch (e) { return ''; }
  }
  function applySale() {
    var n = saleName();
    if (n) [].slice.call(root.querySelectorAll('[data-sale]')).forEach(function (el) { if (el.textContent !== n) el.textContent = n; });
    return !!n;
  }
  /* the script loads async (it can run before or after the page finishes loading), so wait only for what has not happened yet */
  if (!applySale()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applySale);
    if (document.readyState !== 'complete') window.addEventListener('load', applySale); else setTimeout(applySale, 0);
  }

  /* Carousels: like their embla setup (align center, loop). A full set of clones sits on each side of the real slides,
     the track is translated so the active slide is centred, and after each move it jumps back into the real set. */
  function carousel(sec, sel) {
    var vp = sec.querySelector(sel.vp), track = sec.querySelector(sel.track);
    if (!vp || !track) return;
    var orig = [].slice.call(track.children), N = orig.length;
    if (N < 2) return;
    var dots = [].slice.call(sec.querySelectorAll(sel.dot)), btns = [].slice.call(sec.querySelectorAll(sel.btn));
    var mq = sel.off ? matchMedia(sel.off) : null, clones = [], offs = [], i = 0;
    function active() { return !(mq && mq.matches); }
    function quiet(c) {
      c.setAttribute('aria-hidden', 'true');
      [].slice.call(c.querySelectorAll('[id]')).forEach(function (x) { x.removeAttribute('id'); });
      [].slice.call(c.querySelectorAll('a,button,[tabindex]')).forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      clones.push(c); return c;
    }
    function addClones() {
      if (clones.length) return;
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      orig.forEach(function (sl) { before.appendChild(quiet(sl.cloneNode(true))); after.appendChild(quiet(sl.cloneNode(true))); });
      track.insertBefore(before, track.firstChild); track.appendChild(after);
    }
    function removeClones() { clones.forEach(function (c) { c.parentNode && c.parentNode.removeChild(c); }); clones = []; }
    function kids() { return [].slice.call(track.children); }
    function measure() {
      /* the static CSS freezes their loop state (order and translate on a few slides); the script owns positions now */
      kids().forEach(function (sl) { sl.style.order = '0'; sl.style.transform = 'none'; });
      track.style.transition = 'none'; track.style.transform = 'none';
      var tl = track.getBoundingClientRect().left;
      offs = kids().map(function (sl) { var r = sl.getBoundingClientRect(); return { l: r.left - tl, w: r.width }; });
    }
    function place(k, animate) {
      var o = offs[k]; if (!o) return;
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + Math.round((vp.clientWidth - o.w) / 2 - o.l) + 'px)';
      if (!animate) { track.offsetHeight; track.style.transition = ''; }
    }
    function mark() { var d = ((i - N) % N + N) % N; dots.forEach(function (x, k) { x.classList.toggle(sel.on, k === d); }); }
    function settle() { if (i < N) { i += N; place(i, false); } else if (i >= 2 * N) { i -= N; place(i, false); } }
    function move(n) { start(); if (!active()) return; settle(); i = n; place(i, !reduce); mark(); if (reduce) settle(); }
    function step(d) { start(); if (!active()) return; settle(); i += d; place(i, !reduce); mark(); if (reduce) settle(); }
    track.addEventListener('transitionend', function (e) { if (e.target === track && active()) settle(); });
    function init() {
      var d = ((i - N) % N + N) % N;
      if (!active()) {
        removeClones(); kids().forEach(function (sl) { sl.style.order = ''; sl.style.transform = ''; });
        track.style.transform = ''; track.style.transition = ''; vp.style.overflow = ''; return;
      }
      addClones(); vp.style.overflow = 'hidden'; measure(); i = N + d; place(i, false); mark();
    }
    if (btns[0]) btns[0].addEventListener('click', function () { step(-1); });
    if (btns[1]) btns[1].addEventListener('click', function () { step(1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { move(N + k); }); });
    var x0 = null;
    vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    vp.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); });
    vp.addEventListener('pointercancel', function () { x0 = null; });
    var rt; window.addEventListener('resize', function () { if (!started) return; clearTimeout(rt); rt = setTimeout(init, 120); });
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (started) init(); });
    /* The clones copy every slide, pictures included, and a copied picture downloads at once, so the clones are only made when
       the carousel comes within 1200 px of the screen (7 Oct: made at page load they downloaded all seven customer photos,
       about 1 MB, before anyone scrolled). */
    var started = false;
    function start() { if (started) return; started = true; init(); }
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { near.disconnect(); start(); }
      }, { rootMargin: '1200px 0px' });
      near.observe(sec);
    } else start();
  }
  try { var rv = root.querySelector('.gx-reviews-vs-1'); if (rv) carousel(rv, { vp: '.vp', track: '.ct', dot: '.cdot', btn: '.ar', on: 'on', off: '(min-width: 992px)' }); } catch (e) {}
  try { var us = root.querySelector('.gx-users-why-1'); if (us) carousel(us, { vp: '.vp', track: '.cn', dot: '.cdot', btn: '.ab', on: 'on' }); } catch (e) {}

  /* Buy box accordions (one open at a time, like the reference). */
  try {
    var acs = [].slice.call(root.querySelectorAll('.gx-buybox .ac'));
    function setAc(ac, open) { ac.classList.toggle('is-open', open); var b = ac.querySelector('.ac-b'); if (b) b.setAttribute('aria-expanded', String(open)); }
    acs.forEach(function (ac) {
      var b = ac.querySelector('.ac-b'); if (!b) return;
      b.addEventListener('click', function () { var open = !ac.classList.contains('is-open'); acs.forEach(function (o) { setAc(o, false); }); setAc(ac, open); });
    });
  } catch (e) {}

  /* How To Use panel (Grüns' nutrition-label drawer): "See How To Use It" opens it; the X, the dimmed page or Esc close it. */
  try {
    var gd = document.getElementById('gxd');
    if (gd) {
      var gp = gd.querySelector('.gxd__panel'), gc = gd.querySelector('.gxd__close'), gback = null, gt;
      var gtabs = [].slice.call(gd.querySelectorAll('.gxd__tab')), gpanes = [].slice.call(gd.querySelectorAll('.gxd__pane'));
      function gOpen(e) {
        if (e) e.preventDefault();
        clearTimeout(gt); gback = document.activeElement;
        gd.hidden = false; gd.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { requestAnimationFrame(function () { gd.setAttribute('data-open', 'true'); try { gp.focus({ preventScroll: true }); } catch (x) {} }); });
      }
      function gClose() {
        gd.setAttribute('data-open', 'false'); gd.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
        gt = setTimeout(function () { gd.hidden = true; }, 240);
        try { if (gback) gback.focus({ preventScroll: true }); } catch (x) {}
      }
      [].slice.call(document.querySelectorAll('[data-gxd-open]')).forEach(function (a) { a.addEventListener('click', gOpen); });
      gc.addEventListener('click', gClose);
      gd.addEventListener('click', function (e) { if (!gp.contains(e.target)) gClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && gd.getAttribute('data-open') === 'true') gClose(); });
      gtabs.forEach(function (tb) {
        tb.addEventListener('click', function () {
          gtabs.forEach(function (o) { var on = o === tb; o.classList.toggle('is-active', on); o.setAttribute('aria-selected', String(on)); });
          gpanes.forEach(function (pn) { pn.hidden = pn.getAttribute('data-pane') !== tb.getAttribute('data-tab'); });
          gd.querySelector('.gxd__scroll').scrollTop = 0;
        });
      });
    }
  } catch (e) {}

  /* Add to bag + side cart, Grüns' process, THIS PAGE ONLY (blocks/09-cart.html holds the markup). The store's Kaching drawer is hidden
     here and keeps running on every other page.
     Speed (7 Oct, Miljan: "open in a second, no timing issue, loading could be a problem"): the cart, the product prices and the cart
     pictures are fetched quietly once the page has loaded (or the moment a finger touches Add to bag), so a tap opens the cart in the
     same frame, already showing what Shopify will return; the real add runs behind it and the drawer swaps to Shopify's own numbers
     when they land. Cart writes run one at a time in tap order, and Secure Checkout waits for a write still in flight.
     Same FisioRest variant the product page adds (49008945103195). FisioRest is never added twice: the add sets it only when the cart
     does not have it. If the add fails the product page opens. The four gifts ship inside the FisioRest box, so they show as $0 rows,
     never as cart lines. ADDONS below keeps the store's two paid extras that live in Kaching's drawer elsewhere. */
  try {
    var atcs = [].slice.call(root.querySelectorAll('[data-atc-variant]'));
    var gc = root.querySelector('#gx-cart');
    if (atcs.length && gc && window.fetch) {
      var J = { 'Content-Type': 'application/json', Accept: 'application/json' }, A = { Accept: 'application/json' };
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      var money = function (c) {
        var v = (c || 0) / 100;
        if (cur === 'USD') return '$' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', maximumFractionDigits: v % 1 ? 2 : 0 }).format(v); }
        catch (x) { return v.toFixed(2) + ' ' + cur; }
      };
      var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
      var q = function (s) { return gc.querySelector(s); };
      var body = q('[data-gc-body]'), lines = q('[data-gc-lines]'), gifts = q('[data-gc-gifts]'), up = q('[data-gc-up]'), sum = q('[data-gc-sum]'), ft = q('[data-gc-ft]'), co = q('.gc-co');
      var FR = /^2?fisiorest$/, FREE_SHIP = Math.round(4000 * rate);   // the store's free shipping line in the Kaching cart ($40)
      var cartSale = function () { var s = root.querySelector('[data-sale]'); return (s && s.textContent.trim()) || 'Sale'; };
      var abs = function (u) { return !u ? '' : (u.indexOf('//') === 0 ? 'https:' + u : u); };
      var sized = function (u, w) { u = abs(u); return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; };

      /* product data (prices and compare-at in the shopper's currency), fetched once per handle */
      var pdata = {}, preq = {};
      var product = function (h) {
        if (!preq[h]) preq[h] = fetch('/products/' + h + '.js', { headers: A }).then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; }).then(function (p) { pdata[h] = p; return p; });
        return preq[h];
      };
      var variantOf = function (h, vid) { var p = pdata[h]; return p ? (p.variants || []).filter(function (x) { return x.id === vid; })[0] : null; };
      var cmpOf = function (it) { var v = variantOf(it.handle, it.variant_id); return v && v.compare_at_price > it.original_price ? v.compare_at_price : it.original_price; };
      var getCart = function () { return fetch('/cart.js', { headers: A }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }); };
      var readP = null, readAt = 0, readSeq = -1, writeSeq = 0;
      /* one shared read of the cart (a touch on Add to bag starts it early), reused only while no write has finished since it started */
      var freshCart = function (maxAge) {
        if (readP && readSeq === writeSeq && Date.now() - readAt < (maxAge || 2500)) return readP;
        readAt = Date.now(); readSeq = writeSeq;
        readP = getCart().then(function (c) { if (!inflight) { real = c; realAt = Date.now(); } return c; });
        readP.catch(function () { readP = null; });
        return readP;
      };

      /* The store's two paid extras, 5-Year Extended Warranty (Kaching's toggle product kaching-cart-toggle, $9) and Shipping Insurance
         (3-year-protection-plan, $4.95), are offered at checkout (Miljan, 7 Oct: "remove these 2 things from side cart, they appear only
         at checkout"). This cart never adds them. A shopper coming back from checkout with either one in the cart keeps it (their choice
         stays for checkout), but the drawer neither lists it nor counts it in its count and totals. */
      var EXTRAS = [{ pid: 10487165485403, vid: 53003446026587, handle: 'kaching-cart-toggle' }, { pid: 9458094178651, vid: 49009486954843, handle: '3-year-protection-plan' }];
      var isAddonLine = function (it) { return EXTRAS.some(function (x) { return it.product_id === x.pid || it.variant_id === x.vid || it.handle === x.handle; }); };
      var productLines = function (c) { return (c && c.items || []).filter(function (it) { return it.final_price > 0 && !isAddonLine(it); }); };
      var predictAddons = function (c) {   // no product left: Kaching drops its gift too, so the guess does as well
        if (!productLines(c).length) c.items = c.items.filter(function (it) { return !autoGift(it); });
        return c;
      };
      var syncAddons = function (c) { return c; };
      var addItems = function (vid) { return [{ id: vid, quantity: 1 }]; };
      var addonsUi = function () {};
      var addonsClick = function () { return false; };
      var ADDON_HANDLES = [];

      var real = null, realAt = 0, shown = null;   // the last cart Shopify returned (and when) / what the drawer shows now
      var markAtc = function (cart) {
        atcs.forEach(function (a) {
          var vid = parseInt(a.getAttribute('data-atc-variant'), 10);
          a.setAttribute('data-in-cart', (cart.items || []).some(function (it) { return it.variant_id === vid; }) ? 'yes' : 'no');
        });
      };
      var ICON_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';
      var ICON_TAG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9zM7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/></svg>';
      var sigOf = function (c) { return (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join(',') + '|' + c.total_price; };
      var autoGift = function (it) { return !!(it.properties && it.properties._kaching_cart && /isAutoAtcGift/.test(it.properties._kaching_cart)); };
      var isLoading = false, ship = q('[data-gc-ship]'), strip = q('.gc-auto');
      var loading = function () {
        isLoading = true; shown = null;
        lines.innerHTML = '<div class="gc-load" role="status"><span class="gc-spin" aria-hidden="true"></span>Adding FisioRest to your cart...</div>';
        q('[data-gc-count]').textContent = '...';
        gifts.hidden = true; up.hidden = true; sum.hidden = true; ft.hidden = true; ship.hidden = true; strip.hidden = true; addonsUi(null);
      };
      /* one row per product variant: Kaching can split a line in two when it tags it, and two rows of one product read as a bug */
      var groupLines = function (list) {
        var out = [], byV = {};
        list.forEach(function (it) {
          if (it.final_price === 0) { out.push(it); return; }
          var g = byV[it.variant_id];
          if (!g) { g = byV[it.variant_id] = JSON.parse(JSON.stringify(it)); out.push(g); }
          else { g.quantity += it.quantity; g.final_line_price = (g.final_line_price || g.final_price * (g.quantity - it.quantity)) + (it.final_line_price != null ? it.final_line_price : it.final_price * it.quantity); }
        });
        return out;
      };
      /* draw a cart (Shopify's or a predicted one) into the drawer, synchronously */
      var draw = function (cart) {
        shown = cart; isLoading = false;
        var items = groupLines((cart.items || []).filter(function (it) { return !isAddonLine(it); })).sort(function (a, b) {
          var ga = a.final_price === 0, gb = b.final_price === 0;   // paid lines first, FisioRest on top, $0 gift lines (Kaching's) last
          if (ga !== gb) return ga ? 1 : -1;
          return (FR.test(b.handle) ? 1 : 0) - (FR.test(a.handle) ? 1 : 0);
        });
        q('[data-gc-count]').textContent = (cart.items || []).filter(function (it) { return !isAddonLine(it); }).reduce(function (n, it) { return n + it.quantity; }, 0);
        ship.hidden = !items.length; strip.hidden = !items.length;
        var hasFR = items.some(function (it) { return FR.test(it.handle); });
        var hasUp = items.some(function (it) { return it.handle === up.getAttribute('data-handle'); });
        var missing = (cart.items || []).filter(function (it) { return !(it.handle in pdata); }).map(function (it) { return it.handle; });
        if (missing.length) Promise.all(missing.map(product)).then(function () { if (shown === cart) draw(cart); });   // compare-at prices come in a moment later
        if (!items.length) {
          lines.innerHTML = '<div class="gc-empty">Your cart is empty.<button class="gc-ub" type="button" data-gc-add="49008945103195">Add FisioRest</button></div>';
          gifts.hidden = true; up.hidden = true; sum.hidden = true; ft.hidden = true; addonsUi(null);
          q('[data-gc-ship-t]').innerHTML = 'Free shipping on your FisioRest'; q('[data-gc-ship-bar]').style.width = '0%';
          return;
        }
        var was = 0, html = '';
        items.forEach(function (it, i) {
          var free = it.final_price === 0, unit = it.final_price, cmp = cmpOf(it);
          if (i === 0 && !free) html += '<div class="gc-lbl">One-time purchase</div>';
          was += Math.max(cmp, it.original_price) * it.quantity;
          var sub = FR.test(it.handle) ? 'One device, yours to keep' : (it.variant_title && !/^Default/.test(it.variant_title) ? it.variant_title : '');
          var img = sized(it.image, 200);
          var head = '<div class="gc-it' + (free ? ' gc-gift' : '') + '" data-key="' + esc(it.key) + '" data-vid="' + it.variant_id + '" data-q="' + it.quantity + '">';
          if (free) {
            html += '<div class="gc-lbl">Free Gift</div>' + head +
              '<span class="gc-im">' + (img ? '<img src="' + esc(img) + '" alt="" width="200" height="200">' : '') + '</span>' +
              '<div class="gc-in"><div class="gc-nm"><span>' + esc(it.product_title) + '</span>' + (autoGift(it) ? '' : '<button class="gc-rm" type="button" data-gc-rm aria-label="Remove ' + esc(it.product_title) + '">' + ICON_TRASH + '</button>') + '</div>' +
              '<div class="gc-pr">' + money(0) + (cmp > 0 ? '<s>' + money(cmp) + '</s>' : '') + '</div></div></div>';
            return;
          }
          html += head +
            '<a class="gc-im" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="200" height="200">' : '') + '</a>' +
            '<div class="gc-in"><div class="gc-nm"><span>' + esc(it.product_title) + '</span><button class="gc-rm" type="button" data-gc-rm aria-label="Remove ' + esc(it.product_title) + '">' + ICON_TRASH + '</button></div>' +
            (sub ? '<div class="gc-sub">' + esc(sub) + '</div>' : '') +
            '<div class="gc-pr">' + money(unit) + (it.quantity > 1 ? '<span class="gc-x2">(x' + it.quantity + ')</span>' : '') + (cmp > unit ? '<s>' + money(cmp) + '</s>' : '') + '</div>' +
            (cmp > unit ? '<span class="gc-chip">' + ICON_TAG + esc(cartSale()) + '</span><br>' : '') +
            '<span class="gc-q"><button type="button" data-gc-q="-1" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-gc-q="1" aria-label="Increase quantity">+</button></span>' +
            '</div></div>';
        });
        lines.innerHTML = html;
        addonsUi(cart);
        gifts.hidden = !hasFR; up.hidden = hasUp; sum.hidden = false; ft.hidden = false;
        [].slice.call(gc.querySelectorAll('[data-gc-usd]')).forEach(function (s) { s.textContent = money(Math.round(parseInt(s.getAttribute('data-gc-usd'), 10) * rate)); });
        [].slice.call(gc.querySelectorAll('[data-gc-zero]')).forEach(function (s) { s.textContent = money(0); });
        var extras = (cart.items || []).filter(isAddonLine).reduce(function (s, it) { return s + (it.final_line_price != null ? it.final_line_price : it.final_price * it.quantity); }, 0);
        var total = cart.total_price - extras, disc = Math.max(0, was - total);   // the drawer's numbers leave the checkout extras out
        var shipFree = hasFR || total >= FREE_SHIP;
        q('[data-gc-ship-t]').innerHTML = shipFree ? 'Congrats! You’ve unlocked <b>FREE SHIPPING!</b>' : 'You’re ' + money(FREE_SHIP - total) + ' away from <b>FREE SHIPPING</b>';
        q('[data-gc-ship-bar]').style.width = (shipFree ? 100 : Math.max(4, Math.round(total / FREE_SHIP * 100))) + '%';
        q('[data-gc-s-sub]').textContent = money(total);
        q('[data-gc-s-disc-row]').hidden = !disc;
        q('[data-gc-s-disc]').textContent = '-' + money(disc);
        q('[data-gc-s-chips]').innerHTML = '<span class="gc-chip">' + ICON_TAG + esc(cartSale()) + '</span>' + (hasFR ? '<span class="gc-chip">' + ICON_TAG + 'Free Gifts</span>' : '');
        q('[data-gc-s-ship]').textContent = shipFree ? 'FREE SHIPPING' : 'Calculated at checkout';
        var off = was > 0 ? Math.round(disc / was * 100) : 0;
        q('[data-gc-off]').hidden = off < 1; q('[data-gc-off]').textContent = off + '% Off';
        q('[data-gc-was]').hidden = !disc; q('[data-gc-was]').textContent = money(was);
        q('[data-gc-now]').textContent = money(total);
      };
      /* Shopify's answer replaces whatever the drawer guessed */
      var apply = function (cart) {
        if (!cart || !Array.isArray(cart.items)) return getCart().then(function (c) { if (c && Array.isArray(c.items)) apply(c); });
        real = cart; realAt = Date.now(); markAtc(cart);
        if (!shown || sigOf(shown) !== sigOf(cart) || shown !== cart) draw(cart);
        return cart;
      };
      var resync = function () { return getCart().then(apply).catch(function () {}); };

      /* predicted carts, so the drawer answers a tap at once */
      var clone = function (c) { return JSON.parse(JSON.stringify(c || { items: [], item_count: 0, total_price: 0 })); };
      var totals = function (c) {
        c.items = c.items.filter(function (i) { return i.quantity > 0; });
        var t = 0, n = 0;
        c.items.forEach(function (i) { i.final_line_price = i.final_price * i.quantity; t += i.final_line_price; n += i.quantity; });
        c.total_price = t; c.item_count = n; c.predicted = true;
        return c;
      };
      /* the picture Shopify's cart shows: the variant's own image, else the product's first media (for FisioRest a video, so its
         preview image), else the featured image; the guess must show the same picture or it swaps when Shopify answers */
      var cartImage = function (p, v) {
        if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
        var m = p && p.media && p.media[0];
        if (m) return m.preview_image && m.preview_image.src ? m.preview_image.src : m.src;
        return p && p.featured_image;
      };
      var newLine = function (h, vid, props) {
        var p = pdata[h], v = variantOf(h, vid);
        if (!p || !v) return null;
        return { key: 'new:' + vid, variant_id: vid, handle: h, product_title: p.title, variant_title: v.title, url: '/products/' + h,
          image: abs(cartImage(p, v)), quantity: 0,
          original_price: v.price, final_price: v.price, properties: props || {} };
      };
      var predictAdd = function (c, h, vid) {
        c = clone(c);
        var it = c.items.filter(function (i) { return i.variant_id === vid; })[0];
        if (!it) { it = newLine(h, vid); if (!it) return null; c.items.unshift(it); }
        it.quantity += 1;
        return totals(predictAddons(c));
      };
      var predictQty = function (c, key, qty) {
        c = clone(c);
        c.items.forEach(function (i) { if (i.key === key) i.quantity = qty; });
        return totals(predictAddons(c));
      };
      var predictVariantQty = function (c, vid, qty) {   // the whole product (every line of this variant) to one quantity
        c = clone(c); var first = true;
        c.items.forEach(function (i) { if (i.variant_id === vid && i.final_price > 0) { i.quantity = first ? qty : 0; first = false; } });
        return totals(predictAddons(c));
      };

      /* cart writes, one at a time in tap order; Secure Checkout waits for the queue */
      var inflight = 0, queued = 0, queue = Promise.resolve();
      var run = function (fn) {
        inflight++; queued++; gc.setAttribute('data-pending', '');
        var p = queue.then(fn).then(function (c) { writeSeq++; if (c && Array.isArray(c.items)) { real = c; realAt = Date.now(); } return c; },
          function (e) { writeSeq++; throw e; });
        var done = p.then(function (c) { queued--; return c; }, function (e) { queued--; throw e; });
        queue = done.catch(function () {}).then(function () {
          if (--inflight === 0) { gc.removeAttribute('data-pending'); if (!leaving) co.removeAttribute('aria-busy'); if (!gc.classList.contains('is-open')) afterClose(); }
        });
        return done;
      };
      /* checkout and the empty-cart check wait for every write still on its way */
      var whenIdle = function () { return queue.then(function () { return inflight ? whenIdle() : null; }); };
      var post = function (url, data) {
        return fetch(url, { method: 'POST', headers: J, body: JSON.stringify(data) }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
      };
      /* set one product to a quantity: every line of that variant in one /cart/update.js call (first line = qty, the rest 0); read the cart
         first unless Shopify answered a moment ago, and read again and retry once if a key went stale */
      var setQty = function (vid, qty) {
        var keysOf = function (c) { return (c.items || []).filter(function (i) { return i.variant_id === vid && i.final_price > 0; }).map(function (i) { return i.key; }); };
        var sumOf = function (c) { return (c.items || []).filter(function (i) { return i.variant_id === vid && i.final_price > 0; }).reduce(function (n, i) { return n + i.quantity; }, 0); };
        var attempt = function (c) {
          var ks = keysOf(c); if (!ks.length) return Promise.resolve(c);
          var u = {}; ks.forEach(function (k, n) { u[k] = n === 0 ? qty : 0; });
          return post('/cart/update.js', { updates: u });
        };
        var start = real && Date.now() - realAt < 1500 ? Promise.resolve(real) : getCart();
        return start.then(attempt).then(function (c) { if (sumOf(c) !== qty) throw new Error('stale'); return c; })
          .catch(function () { return getCart().then(attempt); });
      };
      var changeLine = function (key, qty, vid) {
        return post('/cart/change.js', { id: key, quantity: qty }).catch(function () {   // a key goes stale when another app touched the cart: find the line again
          return getCart().then(function (c) {
            var m = (c.items || []).filter(function (it) { return it.variant_id === vid; })[0];
            return m ? post('/cart/change.js', { id: m.key, quantity: qty }) : c;
          });
        });
      };
      /* the store's apps change the cart on their own a moment after we do (Kaching adds or drops its gift): look again shortly after */
      var settle = function () {
        [1500, 3500].forEach(function (ms) {
          setTimeout(function () {
            if (!gc.classList.contains('is-open') || inflight) return;
            getCart().then(function (c) { if (c && Array.isArray(c.items) && !inflight && (!real || sigOf(c) !== sigOf(real))) apply(c); }).catch(function () {});
          }, ms);
        });
      };
      var write = function (guess, fn) {
        if (guess) draw(guess);
        return run(function () { return fn().then(syncAddons); }).then(function (c) {
          if (queued === 0) apply(c);   // a later tap is still on its way: keep its guess on screen, draw only the last answer
        }, function () {
          if (queued === 0) { if (real) draw(real); resync(); }   // the write failed (offline, error): back to what Shopify has
        }).then(function () { kachingShut(); if (!queued) settle(); });
      };
      window.addEventListener('online', function () { if (warmed && !inflight) resync(); });

      /* warm-up: cart, product data and the drawer's pictures, fetched once the page is quiet or as soon as a finger lands on Add to bag */
      var warmed = null;
      var warm = function () {
        if (warmed) return warmed;
        var handles = ['fisiorest', up.getAttribute('data-handle')].concat(ADDON_HANDLES);
        warmed = Promise.all([getCart().then(function (c) { if (!real) { real = c; realAt = Date.now(); markAtc(c); } return c; }).catch(function () { return null; })]
          .concat(handles.map(product))).then(function () {
            [].slice.call(gc.querySelectorAll('img[loading="lazy"]')).forEach(function (i) { i.loading = 'eager'; });
            var fr = pdata.fisiorest, v = fr && variantOf('fisiorest', 49008945103195);
            if (fr) { var im = new Image(); im.src = sized(cartImage(fr, v), 200); }
            fillUp();
            (real ? real.items : []).forEach(function (it) { if (it.image) { var i2 = new Image(); i2.src = sized(it.image, 200); } });
          });
        return warmed;
      };
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      if (document.readyState === 'complete') idle(warm); else window.addEventListener('load', function () { idle(warm); });
      if ('IntersectionObserver' in window) {
        var wio = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { wio.disconnect(); warm(); } }, { rootMargin: '1500px 0px' });
        atcs.forEach(function (a) { wio.observe(a); });
      }
      atcs.forEach(function (a) {
        ['pointerdown', 'touchstart', 'mouseenter', 'focus'].forEach(function (ev) { a.addEventListener(ev, warm, { passive: true }); });
        ['pointerdown', 'touchstart'].forEach(function (ev) { a.addEventListener(ev, function () { if (warmed && !inflight) freshCart(2500); }, { passive: true }); });
      });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && warmed && !inflight) resync(); });   // another tab may have changed the cart

      /* the up-sell card shows FisioBack in the shopper's currency (filled once the warm-up has its product data) */
      var fillUp = function () {
        var p = pdata[up.getAttribute('data-handle')], v = p && p.variants && p.variants[0]; if (!v) return;
        q('[data-gc-up-p]').textContent = money(v.price);
        var c = q('[data-gc-up-c]'); c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; c.hidden = !(v.compare_at_price > v.price);
      };

      var lastFocus = null, openedAt = 0, leaving = false, navigating = false, frBusy = false;
      var kachingShut = function () { try { if (window.kachingCartApi && typeof kachingCartApi.closeCart === 'function') kachingCartApi.closeCart(); } catch (x) {} };
      /* Kaching's hidden drawer must never leave the page frozen: clear its lock whenever our drawer is closed */
      var unfreeze = function () {
        if (gc.classList.contains('is-open')) return;
        kachingShut();
        [document.documentElement, document.body].forEach(function (el) { el.classList.remove('kaching-body__cart-open'); });
        if (document.body.style.position === 'fixed') { var y = -parseInt(document.body.style.top || '0', 10) || 0; ['position', 'top', 'left', 'right'].forEach(function (k) { document.body.style[k] = ''; }); if (y) window.scrollTo(0, y); }
      };
      var afterClose = function () { [300, 1500].forEach(function (ms) { setTimeout(unfreeze, ms); }); };   // Kaching reacts a moment after a write lands
      var openCart = function () {
        if (!gc.classList.contains('is-open')) { lastFocus = document.activeElement; openedAt = Date.now(); }
        gc.classList.add('is-open'); gc.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('gc-lock');
        var pnl = q('.gc-p'); if (pnl) setTimeout(function () { try { pnl.focus({ preventScroll: true }); } catch (e) {} }, 50);   // focus moves into the cart without a ring on the close button
      };
      var closeCart = function () {
        gc.classList.remove('is-open'); gc.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('gc-lock');
        kachingShut();
        setTimeout(unfreeze, 400); afterClose();
        if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      };

      gc.addEventListener('click', function (e) {
        var t = e.target;
        if (leaving) { e.preventDefault(); return; }   // on the way to checkout: the cart is frozen as it is
        if (t.closest('[data-gc-close]')) {
          if (t.closest('.gc-ov') && Date.now() - openedAt < 450) return;   // the second click of a double click lands on the overlay
          closeCart(); return;
        }
        if (addonsClick(t)) return;
        var it = t.closest('.gc-it[data-key]');
        if (it && (t.closest('[data-gc-rm]') || t.closest('[data-gc-q]'))) {
          var key = it.getAttribute('data-key'), vid = parseInt(it.getAttribute('data-vid'), 10), qb = t.closest('[data-gc-q]');
          var cur = (shown && shown.items || []).filter(function (x) { return x.variant_id === vid && x.final_price > 0; }).reduce(function (n, x) { return n + x.quantity; }, 0);
          if (it.classList.contains('gc-gift')) {   // a $0 line that may be removed (Kaching's own gift has no remove button)
            write(shown ? predictQty(shown, key, 0) : null, function () { return changeLine(key, 0, vid); });
            return;
          }
          var qty = qb ? Math.max(0, (cur || parseInt(it.getAttribute('data-q'), 10)) + parseInt(qb.getAttribute('data-gc-q'), 10)) : 0;
          write(shown ? predictVariantQty(shown, vid, qty) : null, function () { return setQty(vid, qty); });
          return;
        }
        var ab = t.closest('[data-gc-add]');
        if (ab) {
          var avid = parseInt(ab.getAttribute('data-gc-add'), 10), ah = avid === 49008945103195 ? 'fisiorest' : up.getAttribute('data-handle');
          write(shown ? predictAdd(shown, ah, avid) : null, function () { return post('/cart/add.js', { items: [{ id: avid, quantity: 1 }] }).then(getCart); });
        }
      });
      /* Secure Checkout: with nothing on its way and products in the cart it is a plain link; otherwise it freezes the cart, waits for
         every write to land and goes only if Shopify's cart really holds a product (a failed add must not open an empty checkout) */
      var stopLeaving = function () { leaving = false; gc.classList.remove('is-leaving'); co.removeAttribute('aria-busy'); };
      co.addEventListener('click', function (e) {
        if (!inflight && real && productLines(real).length && !real.predicted) return;
        e.preventDefault();
        if (leaving) return;
        leaving = true; gc.classList.add('is-leaving'); co.setAttribute('aria-busy', 'true');
        whenIdle().then(function () { return real && Date.now() - realAt < 1500 ? real : getCart(); }).then(function (c) {
          if (navigating) return;
          if (c && productLines(c).length) { navigating = true; window.location.href = co.href; }
          else { stopLeaving(); if (c) apply(c); }
        }, stopLeaving);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && gc.classList.contains('is-open')) closeCart(); });
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        stopLeaving(); navigating = false; frBusy = false; closeCart(); resync();
      });

      atcs.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          warm();
          if (leaving || navigating) return;
          var vid = parseInt(a.getAttribute('data-atc-variant'), 10), href = a.href;
          var has = function (c) { return !!c && (c.items || []).some(function (it) { return it.variant_id === vid && it.final_price > 0; }); };
          if (frBusy) { openCart(); return; }   // the add from the last tap is still on its way: just show the cart
          var base = shown || real;            // what the shopper last saw
          var guess = base ? (has(base) ? base : predictAdd(base, 'fisiorest', vid)) : null;
          if (guess) draw(guess);
          else {
            loading();
            warm().then(function () {
              if (!isLoading || !real) return;
              if (has(real)) { draw(real); return; }
              var g = predictAdd(real, 'fisiorest', vid); if (g) draw(g);
            });
          }
          openCart();
          frBusy = true;
          run(function () {
            /* FisioRest is never added twice: the cart is read when this write runs (after any earlier write has landed, so another
               tab, a second tap or Kaching cannot fool it) and FisioRest is added only if that cart lacks it; the drawer is already open
               with the guess, so the read only delays Shopify's confirmation, not the screen */
            return freshCart(2500).then(function (c) {
              if (has(c)) return c;
              return post('/cart/add.js', { items: addItems(vid, c) }).then(getCart);
            }).then(syncAddons);
          }).then(function (c) { frBusy = false; if (queued === 0) apply(c); kachingShut(); if (!queued) settle(); },
            function () { frBusy = false; if (navigating) return; navigating = true; stopLeaving(); closeCart(); window.location.href = href; });
        });
      });
    }
  } catch (e) {}

  /* Buy box gallery: thumbnails pick the slide, swiping updates the thumbnails. */
  try {
    var gvp = root.querySelector('.gx-buybox .gal-vp'), tbs = [].slice.call(root.querySelectorAll('.gx-buybox .gal-tb'));
    if (gvp && tbs.length) {
      var th = tbs[0].parentNode;
      function mark(k) {
        tbs.forEach(function (t, j) { t.classList.toggle('is-on', j === k); t.setAttribute('aria-selected', String(j === k)); });
        /* eight thumbnails scroll in their row (sideways on phones, up and down on desktop): keep the picked one in view, page untouched */
        var t = tbs[k]; if (!t) return;
        var r = t.getBoundingClientRect(), c = th.getBoundingClientRect();
        if (th.scrollWidth > th.clientWidth + 1) th.scrollBy({ left: (r.left + r.width / 2) - (c.left + c.width / 2), behavior: reduce ? 'auto' : 'smooth' });
        else if (th.scrollHeight > th.clientHeight + 1) th.scrollBy({ top: (r.top + r.height / 2) - (c.top + c.height / 2), behavior: reduce ? 'auto' : 'smooth' });
      }
      tbs.forEach(function (t, k) { t.addEventListener('click', function () { gvp.scrollTo({ left: k * gvp.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(k); }); });
      gvp.addEventListener('scroll', function () { mark(Math.round(gvp.scrollLeft / Math.max(1, gvp.clientWidth))); }, { passive: true });
    }
  } catch (e) {}

  /* Reviews widget tabs. */
  try {
    var tabs = [].slice.call(root.querySelectorAll('.gx-widget .tab[data-tab]'));
    tabs.forEach(function (t) {
      function pick() {
        tabs.forEach(function (o) { var on = o === t; o.classList.toggle('on', on); o.setAttribute('aria-selected', String(on)); });
        [].slice.call(root.querySelectorAll('.gx-widget [data-list]')).forEach(function (l) { l.hidden = l.getAttribute('data-list') !== t.getAttribute('data-tab'); });
      }
      t.addEventListener('click', pick);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });
  } catch (e) {}

  /* Reviews widget: "See more reviews" opens 4 more reviews right here (visitors stay on the page, no trip to Trustpilot) and hides
     itself when the open tab has none left. */
  try {
    var moreBtn = root.querySelector('.gx-widget [data-more-btn]');
    if (moreBtn) {
      var openList = function () { return root.querySelector('.gx-widget .list[data-list]:not([hidden])'); };
      var rest = function (list) { return list ? [].slice.call(list.querySelectorAll('.rv[data-more][hidden]')) : []; };
      var sync = function () { moreBtn.hidden = rest(openList()).length === 0; };
      moreBtn.addEventListener('click', function () {
        rest(openList()).slice(0, 4).forEach(function (rv) {
          rv.hidden = false;
          var sp = rv.previousElementSibling; if (sp && sp.hasAttribute('data-more')) sp.hidden = false;
        });
        sync();
      });
      [].slice.call(root.querySelectorAll('.gx-widget .tab[data-tab]')).forEach(function (t) {
        t.addEventListener('click', function () { setTimeout(sync, 0); });
        t.addEventListener('keydown', function () { setTimeout(sync, 0); });
      });
      sync();
    }
  } catch (e) {}

  /* Footer link groups open and close on phones (they are always open from 992 px). */
  try {
    [].slice.call(root.querySelectorAll('.gx-footer .col')).forEach(function (c) {
      var b = c.querySelector('.tg'); if (b) b.addEventListener('click', function () { c.classList.toggle('is-open'); });
    });
  } catch (e) {}

  /* a tap on Add to bag that came before this script (the inline catcher in the buy box held it and opened the loading drawer) */
  window.__gxCartReady = true;
  try { var early = window.__gxEarlyTap; if (early) { window.__gxEarlyTap = null; early.click(); } } catch (e) {}

  root.setAttribute('data-gx-ready', '');   // every handler above is attached (the timing test reads this)
})();
